export default "__VITE_ASSET__mrX_mQM8__"